import Segment from '@/common/utils/tracking/segment'
import type { NavigationItemTrackingData, NavigationCategoryTrackingData } from '@/application/types/navigation-tracking.types'

const allIntegrations = {
  integrations: {
    Mixpanel: true,
    All: true,
  },
}

export default {

  trackNavigationMenuItemClick(params: NavigationItemTrackingData) {
    Segment.track('App - Selected Navigation Item', {
      'Menu Clicked': params.name,
      'Parent Menu': params?.parentSection,
      'Navigation Expanded': params.navigationIsTabletOrMobile ? false : params.navigationMenuIsExpanded,
      'Navigation Table/Mobile': params.navigationIsTabletOrMobile,
    }, allIntegrations)
  },

  trackNavigationExpandOrCollapsed(isExpanded: boolean) {
    Segment.track('App - Navigation - Expand/Collapse', {
      'Navigation Expanded': isExpanded,
      'Navigation Collapse': !isExpanded,
    }, allIntegrations)
  },

  trackNavigationCategoryClicked(params: NavigationCategoryTrackingData) {
    Segment.track('App - Navigation - Selected Category ', {
      'Navigation Category Name': params.name,
      'Navigation Expand': params.isExpanded,
    }, allIntegrations)
  },

}
